// ============================================================================
// API — Contrataciones (panel-super-admin).
// ============================================================================

import { supabaseClient } from '@plataforma/supabase-client';

/**
 * Lista solicitudes de contratacion.
 * @param {{ estado?: string }} [filtros]
 */
export async function listarSolicitudes(filtros = {}) {
  let consulta = supabaseClient()
    .from('solicitud_contratacion')
    .select(
      `
      id,
      empresa_id,
      plan_id,
      estado,
      monto,
      metodo_pago,
      evidencia_url,
      evidencia_mime,
      evidencia_nombre,
      motivo_rechazo,
      creado_en,
      actualizado_en,
      revisado_en,
      revisado_por,
      empresa ( id, nombre, subdominio, estado ),
      plan ( id, nombre, precio_mensual )
    `,
    )
    .order('creado_en', { ascending: false });

  if (filtros.estado) {
    consulta = consulta.eq('estado', filtros.estado);
  }

  const { data, error } = await consulta;

  return { data: data ?? null, error };
}

/**
 * Aprueba una solicitud de contratacion.
 * Solo super_admin.
 */
export async function aprobarSolicitud(solicitudId) {
  const { data, error } = await supabaseClient().rpc('rpc_aprobar_solicitud', {
    p_solicitud_id: solicitudId,
  });

  return { data, error };
}

/**
 * Rechaza una solicitud de contratacion.
 * Solo super_admin.
 */
export async function rechazarSolicitud(solicitudId, motivo) {
  const { data, error } = await supabaseClient().rpc('rpc_rechazar_solicitud', {
    p_solicitud_id: solicitudId,
    p_motivo: motivo,
  });

  return { data, error };
}

/**
 * Obtiene la URL firmada del comprobante.
 * Solo super_admin.
 */
export async function obtenerComprobante(solicitudId) {
  const cliente = supabaseClient();

  let token = null;
  try {
    const session = await cliente.auth.getSession();
    token = session.data.session?.access_token ?? null;
  } catch {
    token = null;
  }

  if (!token) {
    return { data: null, error: { message: 'No autenticado.' } };
  }

  const baseUrl = cliente.supabaseUrl;
  const apiKey = cliente.supabaseKey ?? '';
  const url = `${baseUrl}/functions/v1/obtener_comprobante?solicitud_id=${encodeURIComponent(solicitudId)}`;

  const response = await fetch(url, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
      apikey: apiKey,
    },
  });

  const body = await response.json().catch(() => ({}));

  if (!response.ok) {
    return {
      data: null,
      error: {
        status: response.status,
        code: body.code ?? response.statusText,
        message: body.error ?? response.statusText,
        details: body.details ?? null,
        hint: body.hint ?? null,
      },
    };
  }

  return { data: body, error: null };
}
